import { useKeycloak } from '@react-keycloak/web';

export const useUserClaim = (name) => {
  const { idTokenParsed } = useKeycloak().keycloak;
  return idTokenParsed?.[name];
};
